import React, { useEffect } from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { useNavigate } from 'react-router-dom';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Activities from './Activities';
import { PayloadStates } from '@lore/utils';
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';
import useRouter from '@/hooks/useRouter';

export default function Layout() {
  const { history, match } = useRouter();
  const navigate = useNavigate();

  const user = useUser();
  const offerId = Number(match.params.offerId);
  const safeOfferId = isNaN(offerId) ? -1 : offerId;
  const offer = useConnect('offer.byId', {
    id: safeOfferId
  });

  const activities = useTags(TagTypes.Activity);

  const shouldRedirect = isNaN(offerId) ||
    offer.state === PayloadStates.NOT_FOUND ||
    offer.state === PayloadStates.ERROR_FETCHING ||
    offer.state === PayloadStates.DELETED;

  useEffect(() => {
    if (shouldRedirect) {
      navigate('/my-leading', { replace: true });
    }
  }, [shouldRedirect]);

  if (shouldRedirect ||
    offer.state === PayloadStates.INITIAL_STATE ||
    offer.state === PayloadStates.FETCHING ||
    activities.state === PayloadStates.FETCHING
  ) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Activity"
      title="Which of these sounds most like what you or your organization is willing to offer?"
      // description="Does your lesson, program, or event sound like any of these types of activities?"
      description={(
        <div className="font-semibold">
          Choose ONE Activity Type.
        </div>
      )}
    >
      <Activities
        user={user}
        offer={offer}
        activities={activities}
        onNext={() => history.push(Urls(offer).DESCRIPTION)}
        onSkip={() => history.push(Urls(offer).DESCRIPTION)}
      />
    </ParentLayout>
  );
};
